// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spinner[data-v-2d58a2a8]{display:grid;grid-template-columns:1fr;align-items:center;height:100vh;z-index:999}img[data-v-2d58a2a8]{max-width:30vw;max-height:30vh;margin:0 auto;text-align:center;filter:grayscale(100%);opacity:0.08}\n", ""]);
// Exports
module.exports = exports;
